import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const MotionLink = motion.create(Link);

const q = "?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";
export const OFFERINGS = [
  { key: "exchanges", title: "Learning and Skills Exchanges", text: "Where we share what we know and learn from each other.",
    img: `https://images.unsplash.com/photo-1635491854103-25f890968e1b${q}`, alt: "Learning and Skills Exchanges" },
  { key: "healing", title: "Healing practices and one-on-one sessions", text: "Personal, unhurried time for care and restoration.",
    img: "/photos/healing-drum.webp", alt: "A hand drum and beater resting among plants" },
  { key: "retreats", title: "Retreats and residential programmes on the land", text: "Time away, rooted in place, to slow down and go deeper.",
    img: "/photos/retreat-forest.webp", alt: "Young people building a stick shelter in a misty forest" },
  { key: "community", title: "Community projects where people contribute", text: "Hands-on projects where what we learn becomes something we give.",
    img: "/photos/community-gathering.webp", alt: "A community group holding fresh greens in front of a colourful mural" },
];

export const Offerings = ({ headingAs: Heading = "h2" }) => (
  <section id="offerings" className="py-28 lg:py-36" data-testid="offerings-section">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-primary">What we offer</p>
          <Heading className="mt-6 max-w-2xl font-display text-4xl font-bold leading-tight tracking-tight text-foreground sm:text-5xl">
            Four ways in. <span className="text-primary">One path.</span>
          </Heading>
        </div>
        <p className="max-w-sm text-base text-foreground/70">Begin wherever you are. Each offering connects to the others.</p>
      </div>
      <div className="mt-16 grid gap-px border border-border bg-border md:grid-cols-2 lg:grid-cols-4">
        {OFFERINGS.map((o, i) => (
          <MotionLink key={o.key} to="/contact" data-testid={`offering-card-${o.key}`}
            initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7, delay: i * 0.08 }}
            className={`group relative block h-[460px] overflow-hidden rounded-sm`}>
            <img src={o.img} alt={o.alt} className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-6 p-8">
              <div>
                <h3 className="font-display text-2xl font-bold leading-tight text-white">{o.title}</h3>
                <p className="mt-2 max-w-md text-sm text-white/85">{o.text}</p>
              </div>
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-sm bg-white/90 text-primary transition-transform duration-300 group-hover:rotate-45">
                <ArrowUpRight className="h-5 w-5" />
              </span>
            </div>
          </MotionLink>
        ))}
      </div>
    </div>
  </section>
);
